import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import UserPage from 'flarum/forum/components/UserPage';
import DefaultResolver from 'flarum/common/resolvers/DefaultResolver';
import SellerProfileSection from './components/SellerProfileSection';
/**
 * Aba "Vendedor" no perfil do usuário (substitui a antiga página /loja/{slug}).
 * Vitrine + avaliações ficam numa aba ao lado de Posts/Discussões, vinculadas
 * ao próprio usuário. A aba só aparece em quem tem loja ATIVA
 * (`marketplaceSellerActive`, atributo público do UserResource).
 *
 * Tema avocado: o perfil monta a nav via `page.navItems()` (core), então
 * `extend(UserPage.prototype, 'navItems')` alcança as duas variantes. A página
 * da aba precisa herdar o layout do tema (hero + nav); como o `AvocadoUserBase`
 * só existe depois que o chunk do avocado carrega — e o `mapRoutes` do core
 * captura `route.component` no boot — registramos a rota com um RESOLVER próprio
 * e trocamos `resolver.component` quando o avocado carrega (o `onmatch` lê
 * `this.component` no momento da navegação, então a troca tardia vale). Fora do
 * avocado, cai no core `UserPage`.
 */
const ROUTE = 'marketplace.user_seller';
class CoreSellerUserPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    // Carrega o user direto (find por slug), sem o loadUser/show() do core —
    // que dependem do preload da rota e de history.push(routeName). Nesta rota
    // custom isso deixava this.user nulo → loading eterno. Espelha o avocado.
    const username = m.route.param('username');
    const cached = app.store.all('users').find(u => (u.slug?.() === username || u.username?.() === username) && u.joinTime?.());
    if (cached) {
      this.user = cached;
      return;
    }
    app.store.find('users', username, {
      bySlug: true
    }).then(u => {
      this.user = u;
      if (u?.displayName) app.setTitle(u.displayName());
      m.redraw();
    }).catch(() => m.redraw());
  }
  content() {
    return m(SellerProfileSection, {
      user: this.user
    });
  }
}
export default function addSellerProfileTab() {
  const resolver = new DefaultResolver(CoreSellerUserPage, ROUTE);
  app.routes[ROUTE] = {
    path: '/u/:username/seller',
    resolver
  };

  // No avocado, estende o AvocadoUserBase para herdar hero + nav do tema.
  flarum.reg.onLoad('ramon-avocado', 'forum/components/UserProfilePage', mod => {
    const sample = mod?.AvocadoUserPostsPage;
    if (!sample) return;
    const Base = Object.getPrototypeOf(sample);
    if (typeof Base !== 'function') return;
    class AvocadoSellerUserPage extends Base {
      content() {
        return m(SellerProfileSection, {
          user: this.user
        });
      }
    }
    // Atualiza o resolver vivo — o onmatch usa este componente na próxima navegação.
    resolver.component = AvocadoSellerUserPage;
  });

  // Aba "Vendedor" — só em perfis com loja ativa.
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    if (!user || typeof user.attribute !== 'function' || !user.attribute('marketplaceSellerActive')) return;
    const username = typeof user.slug === 'function' ? user.slug() : user.username();
    items.add('marketplace-seller', LinkButton.component({
      href: app.route(ROUTE, {
        username
      }),
      icon: 'fas fa-store'
    }, app.translator.trans('ramon-marketplace.forum.seller_profile.tab')), 50);
  });
}